import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { authFetch } from "@/lib/api";
import ConventionsPanel from "@/components/admin/ConventionsPanel";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Espace coordinateur : faire signer les conventions et consulter le registre. */
export default function ConventionsPage() {
  const navigate = useNavigate();
  const [me, setMe] = useState(null);

  useEffect(() => {
    authFetch(`${API_BASE}/auth/me`)
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then((u) => {
        if (!(u.is_coordinator || u.is_admin)) { navigate("/dashboard", { replace: true }); return; }
        setMe(u);
      })
      .catch(() => navigate("/", { replace: true }));
  }, [navigate]);

  if (!me) {
    return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin" style={{ color: "#2D6A4F" }} /></div>;
  }

  return (
    <div className="min-h-screen flex flex-col" style={{ background: "#FAFAF8" }} data-testid="conventions-page">
      <header className="flex items-center gap-3 px-4 py-3 bg-white border-b" style={{ borderColor: "#E5E5E0" }}>
        <button onClick={() => navigate(-1)} className="p-1.5 rounded-lg hover:bg-black/5" aria-label="Retour"><ArrowLeft className="w-4 h-4" /></button>
        <div>
          <h1 className="text-sm font-bold" style={{ color: "#1A1A1A" }}>Conventions de bêta-test</h1>
          <p className="text-[11px]" style={{ color: "#7A7A7A" }}>
            {me.is_coordinator ? "Espace coordinateur" : "Administration"} · {me.name || me.email}
          </p>
        </div>
      </header>
      <main className="flex-1 p-4">
        <p className="max-w-5xl mx-auto mb-3 text-[12px]" style={{ color: "#4A4A4A" }}>
          « Faire signer une convention » ouvre le formulaire dans un nouvel onglet : remplissez-le avec le producteur et faites-le signer.
          La convention est enregistrée à votre nom, et le producteur reçoit son exemplaire PDF par e-mail.
        </p>
        <ConventionsPanel canDelete={false} />
      </main>
    </div>
  );
}
